<template>
    <div class="cart">
      <div class="configurator-header">
        <div class="logo-container">
          <img src="https://sander-gruppe.eu/wp-content/uploads/2019/07/ms-logo.png" alt="Ihr Logo" class="logo" @click="goToDashboard">
        </div>
        <div class="flex-down">
          <div class="component-container-header">
            Warenkorb
          </div>
          <div v-if="selectedProject" class="component-container-header">
            Projekt: {{ selectedProject != null ? selectedProject.name : "" }}
          </div>
        </div>
      </div>
      <div v-if="selectedProject" class="project-notes">
        <textarea 
          id="projectNotes"
          v-model="selectedProject.notizen"
          @blur="updateProjectNotes"
          placeholder="Geben Sie hier Ihre Notizen ein"
          rows="5"
          cols="50"
        ></textarea>
      </div>
      <CartItem
        v-for="item in cartItems"
        :key="item.positionBez"
        ref="cartItemsRefs"
        :pos="item.pos"
        :id="item.id"
        :articleId="item.articleId"
        :articleSearchText="item.articleSearchText"
        :priorityFolders="item.priorityFolders"
        :positionBez="item.positionBez"
        :items="item.items"
        :price="item.price"
        :productImage="item.productImage"
        :amount="item.amount"
        :notes="item.notes"
        :discount="item.discount"
        @image-loaded="updateProductImage"
        @remove-item="confirmRemoveItemFromCart"
        @copy-item="confirmCopyItemToCart"
        @open-item="openItemInMainComponent"
        @quantity-changed="handleQuantityChanged"
      />
    </div>
    <div class="sum">
      <div class="rows">
        <div class="row">
          <div class="space"></div>
          <div class="left">Nettowert</div>
          <div class="right">{{ `${(netto).toFixed(2)} €` }}</div>
        </div>
        <div class="row">
          <div class="space"></div>
          <div class="left">Teuerungszuschlag ({{ tz.toFixed(1).toString().replace('.', ',') }}%)</div>
          <div class="right">{{ `${(tzNetto).toFixed(2)} €` }}</div>
        </div>
        <div class="row" v-if="lieferBedingungen != null">
          <div class="space"></div>
          <div class="left">Lieferkosten ({{ `${lieferBedingungen.l_bed_bezeichnung}` }})</div>
          <div class="right" v-if="lieferBedingungen.liefer_kosten > 0.0">{{ `${Number(lieferBedingungen.liefer_kosten).toFixed(2)} €` }}</div>
          <div class="right" v-if="lieferBedingungen.liefer_kosten <= 0.0">{{ `${lieferBedingungen.liefer_text}` }}</div>
        </div>
        <div class="separator-row">

        </div>
        <div class="row">
          <div class="space"></div>
          <div class="left">Zwischensumme</div>
          <div class="right">{{ `${(zwischenSum).toFixed(2)} €` }}</div>
        </div>
        <div class="row vat-row">
          <div class="space"></div>
          <div class="left">zzgl. 19% MwSt.</div>
          <div class="right">{{ `${(mwst).toFixed(2)} €` }}</div>
        </div>
        <div class="total-row">

        </div>
        <div class="row">
          <div class="space"></div>
          <div class="left">Bruttobetrag</div>
          <div class="right">{{ `${(brutto).toFixed(2)} €` }}</div>
        </div>
      </div>
      <div class="button-container">
        <button class="button-with-icon" @click="confirmSendCartItems">
          <img class="icon-in-button" :src="require('@/assets/dashboard/paper-plane-solid-dark-grey.svg')" alt="Icon" />
          Bestellung senden
        </button>
        <button class="button-with-icon" @click="confirmSendInquiry">
          <img class="icon-in-button" :src="require('@/assets/dashboard/message-solid-dark-grey.svg')" alt="Icon" />
          Anfrage senden
        </button>
        <button class="button-with-icon" @click="newPosition">
          <img class="icon-in-button" :src="require('@/assets/dashboard/plus-solid-dark-grey.svg')" alt="Icon" />
          Neue Position
        </button>
        <button class="button-with-icon" @click="goToDashboard">
          <img class="icon-in-button" :src="require('@/assets/dashboard/house-solid-dark-grey.svg')" alt="Icon" />
          Zum Dashboard
        </button>
      </div>
    </div>
    <div class="footer">
        <div class="footer-text">
            ms-Sprossenelemente GmbH - alle aufgeführten Preise zzgl. gesetzlicher MwSt. und Versand
        </div>
        <div class="footer-first-row">
            <img :src="require('@/assets/footer/Icon-awesome-facebook.svg')" alt="Facebook">
            <img :src="require('@/assets/footer/Icon-awesome-instagram.svg')" alt="Instagram">
            <img :src="require('@/assets/footer/Icon-awesome-linkedin.svg')" alt="linkedIn">
            <img :src="require('@/assets/footer/Icon-simple-xing.svg')" alt="Xing">
            <img :src="require('@/assets/footer/Icon-awesome-youtube.svg')" alt="Youtube">
            <img :src="require('@/assets/footer/Icon-awesome-whatsapp-square.svg')" alt="Whatsapp">
        </div>
        <div class="footer-second-row">
            <img :src="require('@/assets/footer/Sander-Gruppe.png')" alt="Sander-Logo">
        </div>
    </div>
    <div v-if="showDialog" class="dialog">
      <div class="dialog-content">
        <p>{{ dialogMessage }}</p>
        <button @click="closeDialog">OK</button>
      </div>
    </div>
    <div v-if="isLoading" class="loading-overlay">
      <div class="spinner"></div>
    </div>
    <confirmation-dialog 
      v-if="showCartDeleteConfirmation" 
      :message="'Möchten Sie diesen Artikel wirklich aus dem Warenkorb entfernen?'" 
      @confirm="removeItemFromCart"
      @cancel="cancelRemoveItemFromCart"
    />
    <confirmation-dialog 
      v-if="showCartCopyConfirmation" 
      :message="'Möchten Sie diesen Artikel wirklich kopieren?'" 
      @confirm="copyItemToCart"
      @cancel="cancelCopyItemToCart"
    />
    <confirmation-dialog 
      v-if="showSendInquiryConfirmation" 
      :message="'Möchten Sie die Anfrage abschicken?'" 
      @confirm="sendInquiry"
      @cancel="cancelSendInquiry"
    />
    <confirmation-dialog 
      v-if="showSendCardItemsConfirmation" 
      :message="'Möchten Sie die Bestellung abschicken?'" 
      @confirm="sendCartItems"
      @cancel="cancelSendCartItems"
    />
  </template>
  
  <script>
  import api from '@/api/client';
  import CartItem from './WarenkorbItemComponent.vue';
  import ConfirmationDialog from './ConfirmationDialog.vue';

  // Artikel-IDs, die sich einen Rabatt-Index teilen sollen.
  // key = Artikel-ID, value = gewünschter Rabatt-Index
  const DISCOUNT_INDEX_BY_ARTICLE = {
    1: 1,   // 100 u 200er
    2: 2,
    3: 2,
    4: 3,
    5: 3,
    6: 3,
    7: 3,
    8: 3,
    9: 3,
    10: 4,
    11: 4,
    12: 4,
    13: 5,
    14: 5,
    15: 6,
    16: 7,
    17: 8,
    18: 8,
    19: 8,
    20: 8,
    21: 9,
    22: 9,
    23: 9,
    24: 9,
    25: 10,
    26: 11,
    27: 11,
    28: 11,
    29: 10,
    30: 10,
  };

  
  export default {
    components: {
      CartItem,
      ConfirmationDialog
    },
    data() {
      return {
        company: null,
        loggedInUser: null,
        cartItems: [
          {
            pos: 1,
            articleId: 1,
            articleSearchText: "Kein Artikel im Warenkorb",
            items: [
              
            ],
            price: 0,
            productImage: 'pfad/zum/bild1.jpg'
          },
          // Füge weitere Produktobjekte hier ein
        ],
        netto: 0.0,
        mwst: 0.0,
        zwischenSum: 0.0,
        brutto: 0.0,
        tz: 0.0,
        tzNetto: 0.0,
        showDialog: false, // Steuert die Anzeige des Dialogs
        dialogMessage: '', // Nachricht, die im Dialog angezeigt wird
        isLoading: false,
        showSendInquiryConfirmation: false,
        showSendCardItemsConfirmation: false,
        showCartDeleteConfirmation: false,
        showCartCopyConfirmation: false,
        positionBezToDelete: null,
        copiedItem: null,
        selectedProject: null,
        discounts: [],
        lieferBedingungen: null,
        extraCharge: [],
      };
    },
    methods: {
      getDiscountIndexForArticle(articleId) {
        const numericId = Number(articleId);
        if (Number.isNaN(numericId)) {
          return 0;
        }
        const mapped = DISCOUNT_INDEX_BY_ARTICLE[numericId];
        if (mapped != null) {
          return mapped;
        }

        return (numericId >= 0 && numericId < this.discounts.length) ? numericId : 0;
      },
      updateProductImage({ id, newPath }) {
        const item = this.cartItems.find(c => c.id === id);
        if (item) {
          item.productImage = newPath;
        }
      },
      async scrollToItem(targetId = null) {
        await this.$nextTick();
        const itemComponents = Array.isArray(this.$refs.cartItemsRefs) ? this.$refs.cartItemsRefs : [];
        if (!itemComponents.length) return;

        const targetComponent = targetId != null
          ? itemComponents.find(c => c.id === targetId)
          : null;

        const component = targetComponent || itemComponents[itemComponents.length - 1];
        if (!component || !component.$el) return;

        if (typeof component.$el.scrollIntoView === 'function') {
          component.$el.scrollIntoView({ behavior: 'smooth', block: 'center', inline: 'nearest' });
        }

        if (typeof component.flashHighlight === 'function') {
          component.flashHighlight();
        }
      },
      sleep(ms = 150) {
        return new Promise(resolve => setTimeout(resolve, ms));
      },
      async updateProjectNotes() {
        if (this.selectedProject && this.selectedProject.notizen) {
          try {
            await api.put(`/api/projekte/${this.selectedProject.id}`, {
              notizen: this.selectedProject.notizen
            });
            console.log('Notizen wurden erfolgreich aktualisiert.');
          } catch (error) {
            console.error('Fehler beim Aktualisieren der Notizen:', error);
          }
        }
      },
      async getProjectDeliveryConditions() {
        try {
          if (this.company == null) {
            this.company = this.$parent.getCompany();
          }
          const response = await api.get(`/api/delivery_conditions/${this.company.delivery_condition_id}`);
          if (response.data && response.data.length > 0) {
            this.lieferBedingungen = {
              berechnung: response.data[0].berechnung,
              l_bed_bezeichnung: response.data[0].l_bed_bezeichnung,
              l_bed_nummer: response.data[0].l_bed_nummer,
              liefer_kosten: 0.0,
              liefer_text: "",
              prozent_satz: 0.0,
              mindest_satz: 0.0,
              maximal_satz: 0.0,
              frei_ab: 0.0,
              berechnung_vorhanden: false,
            };

            if (response.data[0].berechnung == null) {
              this.lieferBedingungen.liefer_text = "-";
            }
            else {
              var tmpLieferText = response.data[0].berechnung.split("t:");
              if (tmpLieferText.length > 1) {
                this.lieferBedingungen.liefer_text = tmpLieferText[1];
              } 
              else {
                // Sätze definieren
                var tmpBerechnung = response.data[0].berechnung.split(";");
                this.lieferBedingungen.berechnung_vorhanden = true;

                for (var i = 0; i < tmpBerechnung.length; ++i) {
                  if (tmpBerechnung[i].includes("p:")) {
                    this.lieferBedingungen.prozent_satz = parseFloat(tmpBerechnung[i].split(":")[1]);
                  }
                  else if(tmpBerechnung[i].includes("mi:")) {
                    this.lieferBedingungen.mindest_satz = parseFloat(tmpBerechnung[i].split(":")[1]);
                  }
                  else if(tmpBerechnung[i].includes("ma:")) {
                    this.lieferBedingungen.maximal_satz = parseFloat(tmpBerechnung[i].split(":")[1]);
                  }
                  else if(tmpBerechnung[i].includes("fr:")) {
                    this.lieferBedingungen.frei_ab = parseFloat(tmpBerechnung[i].split(":")[1]);
                  }
                }
              }
            }
          }
          this.refreshCartSumPrice(); // Aktualisiere die Summe, nachdem der Rabatt geladen wurde
        } catch (error) {
          console.error('Fehler beim Abrufen der Lieferbedingungen:', error);
        }
      },
      async getCartExtraCharge() {
        const response = await api.get(`/api/discounts/unternehmen/${this.company.id}`);
        this.extraCharge = response.data.filter(item => item.type == 1);

        for (let i = 0; i < this.extraCharge.length; ++i) {
          // 10 Teuerungsaufschlag
          if (this.extraCharge[i].kuerzel == "TZ") {
            // Backend liefert hier teils Strings (ggf. mit Komma). Immer in Number wandeln,
            // damit toFixed im Template nicht auf einem String aufgerufen wird.
            const parsedTz = parseFloat(String(this.extraCharge[i].rabatt).replace(',', '.'));
            this.tz = isNaN(parsedTz) ? 0.0 : parsedTz;
          }
        }
      },
      async getProjectDiscount() {
        try {
          const response = await api.get(`/api/discounts/unternehmen/${this.company.id}`);
          // Nur die discounts für die Beschläge
          response.data = response.data.filter(item => item.type == 0);
          this.discounts = [];
          if (response.data && response.data.length > 0) {
            response.data.forEach(dataSet => {
              this.discounts.push(dataSet.rabatt);
            });
            for (let i = this.discounts.length; i < 15; ++i) {
              this.discounts.push(this.discounts[0]);
            }
          } else {
            for(let i = 0; i < 15; ++i) {
              this.discounts.push(0.0); // Fallback auf 0, falls kein Rabatt gefunden wurde
            } 
          }
          this.refreshCartSumPrice(); // Aktualisiere die Summe, nachdem der Rabatt geladen wurde
        } catch (error) {
          console.error('Fehler beim Abrufen des Projektrabatts:', error);
          for(let i = 0; i < 15; ++i) {
              this.discounts.push(0.0); // Fallback auf 0, falls kein Rabatt gefunden wurde
          } 
        }
        const baseDiscount = this.discounts[0] ?? 0;
        this.cartItems.forEach(cartItem => {
          const idx = this.getDiscountIndexForArticle(cartItem.articleId);
          cartItem.discount = this.discounts[idx] ?? baseDiscount;
        });
      },
      parseSMassDisplayValue(displayValue) {
        if (!displayValue || typeof displayValue !== 'string') {
          return { s: null, groupText: null, smk: null, fa: null };
        }

        const text = displayValue.trim();
        const re = /^\s*(\d+)\s*mm(?:\s*\(([^)]+)\))?(?:\s+(\d+)\s*mm)?(?:\s+(\d+)\s*mm)?\s*$/i;
        const m = text.match(re);

        if (!m) {
          return { s: null, groupText: null, smk: null, fa: null };
        }

        const [, s, groupText, smk, fa] = m;

        return {
          s: s != null ? Number(s) : null,
          groupText: groupText || null,
          smk: smk != null ? Number(smk) : null,
          fa: fa != null ? Number(fa) : null,
        };
      },
      parseFluegelDisplayValue(displayValue) {
        const nums = Array.from(String(displayValue || '').matchAll(/(\d+(?:[.,]\d+)?)/g)).map(m => m[1].replace(',', '.'));
        if (nums.length === 0) {
          return { left: null, right: null, height: null };
        }

        const left = nums[0] ?? null;
        const right = nums.length >= 3 ? nums[2] : (nums[1] ?? null);
        const height = nums.length >= 2 ? nums[1] : null;

        return { left, right, height };
      },
      normalizeDimensionValue(val) {
        return (val ?? '').toString().replace(/mm/ig, '').replace(/,/g, '.').trim();
      },
      getHeightFromItems(items = []) {
        const dimItem = (items || []).find(it => {
          const n = (it.name || '').toLowerCase();
          return n.includes('maß') && !n.includes('s-maß');
        });
        if (dimItem && typeof dimItem.value === 'string') {
          const parsedDim = this.parseFluegelDisplayValue(dimItem.value);
          if (parsedDim.height) {
            return this.normalizeDimensionValue(parsedDim.height);
          }
          if (parsedDim.right) {
            return this.normalizeDimensionValue(parsedDim.right);
          }
        }
        return null;
      },
      getFormattedCartItemValue(item, siblingItems = []) {
        const rawValue =
          item.value != null && String(item.value).trim() !== ''
            ? item.value
            : (item.emptyValue != null ? item.emptyValue : item.value);

        if (item.name === 'S-Maß' && typeof rawValue === 'string') {
          const parsed = this.parseSMassDisplayValue(rawValue);

          if (parsed?.smk != null && parsed?.groupText) {
            const groupNumberMatch = parsed.groupText.match(/\d+/);
            const groupNumber = groupNumberMatch ? groupNumberMatch[0] : parsed.groupText;
            return `S-Maß (Klammer) ${parsed.smk}mm aus Gr. ${groupNumber}`;
          }
        }

        if (item.name === 'Flügel' && typeof rawValue === 'string') {
          const parsed = this.parseFluegelDisplayValue(rawValue);
          const left = parsed.left ? this.normalizeDimensionValue(parsed.left) : null;
          const right = parsed.right ? this.normalizeDimensionValue(parsed.right) : null;
          const heightRaw = this.getHeightFromItems(siblingItems) || parsed.height;
          const height = heightRaw ? this.normalizeDimensionValue(heightRaw) : null;

          if (left && right && height) {
            return `${left}mm x ${height}mm / ${right}mm x ${height}mm`;
          }
          if (left && right) {
            return `${left}mm x ${right}mm`;
          }
        }

        return rawValue;
      },
      getMailCartItems() {
        return this.cartItems.map(cartItem => ({
          ...cartItem,
          items: (cartItem.items || []).map(item => ({
            ...item,
            value: this.getFormattedCartItemValue(item, cartItem.items || [])
          }))
        }));
      },
      removeItemFromCart() {
        var actualCartItem = this.cartItems.find(item => item.id === this.positionBezToDelete);
        this.showCartDeleteConfirmation = false;
        this.cartItems = this.cartItems.filter(item => item.id !== this.positionBezToDelete);
        this.refreshCartItemPostion();
        this.$nextTick(() => {
          this.$parent.deletePositionWithID(actualCartItem.id);
          this.refreshCartSumPrice();
        });
      },
      refreshCartItemPostion() {
        for(let i = 0; i < this.cartItems.length; ++i) {
          this.cartItems[i].pos = i + 1;
        }
      },
      confirmSendInquiry() {
        this.showSendInquiryConfirmation = true;
      },
      confirmSendCartItems() {
        this.showSendCardItemsConfirmation = true;
      },
      confirmCopyItemToCart(copyItm) {
        this.copiedItem = copyItm;
        this.showCartCopyConfirmation = true;
      },
      confirmRemoveItemFromCart(positionId) {
        this.positionBezToDelete = positionId;
        this.showCartDeleteConfirmation = true;
      },
      cancelCopyItemToCart() {
        this.showCartCopyConfirmation = false;
      },
      cancelRemoveItemFromCart() {
        this.showCartDeleteConfirmation = false;
      },
      cancelSendInquiry() {
        this.showSendInquiryConfirmation = false;
      },
      cancelSendCartItems() {
        this.showSendCardItemsConfirmation = false;
      },
      async copyItemToCart() {
        this.showCartCopyConfirmation = false;
        //this.cartItems.push(this.copiedItem);
        //this.refreshCartSumPrice();
        //await this.$parent.saveCopiedItemToMain(this.copiedItem);
        this.$parent.setLoading(true);
        setTimeout(() => {
          this.$parent.openFromCard(this.copiedItem);
          this.$parent.resetCopiedItem();
          this.$parent.setPosition(this.getNextAvailablePosition());
          this.$parent.toggleCart();
          this.$parent.setLoading(false);
          this.$parent.selectPositionContentFromCart();
          this.$parent.setCopyMode();
        }, 2000);
      },
      openItemInMainComponent(itemToOpen) {
        this.$parent.openFromCard(itemToOpen);
        this.$parent.setPosition(itemToOpen.pos);
        this.$parent.toggleCart();
      },
      newPosition() {
        this.$parent.clearFields();
        this.$parent.setPosition(this.getNextAvailablePosition());
        this.$parent.toggleCart();
      },
      getNextAvailablePosition() {
        return this.cartItems.length + 1;
      },
      goToDashboard() {
        this.$parent.toggleCart();
        this.$parent.goBack();
      },
      async setCardItems(savedValues) {
        this.isLoading = true;
        try {
          this.cartItems = [];
          var config = null;
          var cartItem = null;
          for (let savedValue of savedValues) {
            config = JSON.parse(savedValue.artikel_json);
            cartItem = {
              id: savedValue.id,
              articleId: config.articleId,
              positionBez: savedValue.position_bezeichnung,
              articleSearchText: config.articleSearchText,
              priorityFolders: config.priorityFolders ?? null,
              items: config.items,
              price: config.price,
              productImage: 'pfad/zum/bild1.jpg',
              amount: savedValue.anzahl,
              notes: savedValue.notizen,
              discount: 0.0,
              rawJson: savedValue.artikel_json
            };
            this.cartItems.push(cartItem);
          }
          this.refreshCartItemPostion();
          await this.getProjectDiscount();
          await this.sleep();
          await this.getProjectDeliveryConditions();
          await this.sleep();
          await this.getCartExtraCharge();
          await this.sleep(100);
          await this.$nextTick();
          await this.reloadCartImagesAndSum();
        } finally {
          this.isLoading = false;
        }
      },
      sendCartItems() {
        const formattedItems = this.getMailCartItems();
        
        this.showSendInquiryConfirmation = false;
        this.showSendCardItemsConfirmation = false;
        var tmpCompanyArray = [this.company];
        var tmpUserArray = [this.loggedInUser];
        this.isLoading = true;
        api.post('/api/sendcart', { 
          items: formattedItems, 
          company: tmpCompanyArray, 
          user: tmpUserArray,
          tz: this.tz,
          tzNetto: this.tzNetto,
          netto: this.netto, 
          mwst: this.mwst, 
          zwischenSum: this.zwischenSum,
          brutto: this.brutto,
          lieferkosten_bez: this.lieferBedingungen?.l_bed_bezeichnung ?? null,
          lieferkosten_text: this.lieferBedingungen?.liefer_text ?? null,
          lieferkosten_betrag: this.lieferBedingungen?.liefer_kosten ?? null,
          notizen: this.selectedProject.notizen,
          project_name: this.selectedProject.name,
          projekt_id: this.selectedProject?.id ?? null,
        })
        .then(() => {
          this.dialogMessage = 'Ihre Bestellung wurde erfolgreich übermittelt!';
          this.showDialog = true;
        })
        .catch(error => {
            console.error('Es gab einen Fehler beim senden des Warenkorbs: ', error);
        }).finally(() => {
          this.isLoading = false;
        });
      },
      setSelectedProject(selectedProject) {
        this.selectedProject = selectedProject;
      },
      sendInquiry() {
        const formattedItems = this.getMailCartItems();

        this.showSendInquiryConfirmation = false;
        this.showSendCardItemsConfirmation = false;
        const tmpCompanyArray = [this.company];
        const tmpUserArray = [this.loggedInUser];

        this.isLoading = true;

        api.post('/api/sendrequest', {
          items: formattedItems,
          company: tmpCompanyArray,
          user: tmpUserArray,
          tz: this.tz,
          tzNetto: this.tzNetto,
          netto: this.netto,
          mwst: this.mwst,
          zwischenSum: this.zwischenSum,
          brutto: this.brutto,
          lieferkosten_bez: this.lieferBedingungen?.l_bed_bezeichnung ?? null,
          lieferkosten_text: this.lieferBedingungen?.liefer_text ?? null,
          lieferkosten_betrag: this.lieferBedingungen?.liefer_kosten ?? null,
          notizen: this.selectedProject.notizen,
          project_name: this.selectedProject.name,
          projekt_id: this.selectedProject?.id ?? null,
        })
        .then(() => {
          this.dialogMessage = 'Ihre Anfrage wurde erfolgreich übermittelt!';
          this.showDialog = true;
        })
        .catch(error => {
          console.error('Es gab einen Fehler beim Senden der Anfrage: ', error);
        })
        .finally(() => {
          this.isLoading = false;
        });
      },
      async reloadCartImagesAndSum() {
        const cartItemComponents = Array.isArray(this.$refs.cartItemsRefs) ? this.$refs.cartItemsRefs : [];
        await Promise.all(cartItemComponents.map(c => c.loadImageForCart()));
        this.refreshCartSumPrice();
      },
      async handleQuantityChanged({ id, amount }) {
        const item = this.cartItems.find(c => c.id === id);
        if (item) {
          item.amount = amount;
        }
        this.refreshCartSumPrice();
        try {
          await api.put(`/api/gespeicherteartikel/${id}`, {
            position_bezeichnung: item?.positionBez,
            artikel_json: item?.rawJson ?? JSON.stringify({
              articleId: item?.articleId,
              articleSearchText: item?.articleSearchText,
              priorityFolders: item?.priorityFolders,
              items: item?.items,
              price: item?.price,
            }),
            anzahl: amount,
            notizen: item?.notes,
            projekt_id: this.selectedProject?.id ?? null,
          });
        } catch (e) {
          console.error('Fehler beim Aktualisieren der Menge:', e);
        }
      },
      async refreshCart() {
        this.isLoading = true;
        try {
          this.company = this.$parent.getCompany();
          this.loggedInUser = this.$parent.getLoggedInUser();
          await this.reloadCartImagesAndSum();
        } finally {
          this.isLoading = false;
        }
      },
      refreshCartSumPrice() {
        this.netto = 0.0;
        let index = 0;
        this.$refs.cartItemsRefs.forEach(cartItemComponent => {
          // Berücksichtige den Rabatt bei der Berechnung des Nettowerts
          const itemPriceWithDiscount = cartItemComponent.price * cartItemComponent.getSelectedQuantity() * (1 - cartItemComponent.discount / 100);
          this.netto += itemPriceWithDiscount;
          this.cartItems[index].amount = cartItemComponent.getSelectedQuantity();
          ++index;
        });
        // Kaufmännisches Runden des Netto-Betrags
        this.netto = parseFloat(this.netto.toFixed(2));
        this.tzNetto = parseFloat(this.netto.toFixed(2) * this.tz / 100.0);
        
        // Berechnung der Lieferkosten
        var lieferKosten = 0.0;
        if (this.lieferBedingungen != null && this.lieferBedingungen.berechnung_vorhanden) {
          this.lieferBedingungen.liefer_kosten = parseFloat(this.netto * this.lieferBedingungen.prozent_satz / 100.0);
          if (this.lieferBedingungen.liefer_kosten < this.lieferBedingungen.mindest_satz) {
            this.lieferBedingungen.liefer_kosten = this.lieferBedingungen.mindest_satz;
          }
          else if (this.lieferBedingungen.liefer_kosten > this.lieferBedingungen.maximal_satz) {
            this.lieferBedingungen.liefer_kosten = this.lieferBedingungen.maximal_satz;
          }
          if (this.lieferBedingungen.frei_ab > 0.0) {
            if (this.netto > this.lieferBedingungen.frei_ab) {
              this.lieferBedingungen.liefer_kosten = 0.0;
              this.lieferBedingungen.liefer_text = "Lieferung frei";
            }
          }
          lieferKosten = this.lieferBedingungen.liefer_kosten;
        }
        this.zwischenSum = this.netto + this.tzNetto + lieferKosten;
        // Berechnung der MWST
        this.mwst = (this.zwischenSum  * 19.0) / 100.0;
        // Kaufmännisches Runden der MWST
        this.mwst = parseFloat(this.mwst.toFixed(2));
        this.brutto = parseFloat(this.zwischenSum + this.mwst);
      },
      closeDialog() {
        this.showDialog = false;
        this.goToDashboard();
      },
    }
  };
  </script>

<style scoped src="@/styles/WarenkorbComponent.css">

</style>
